module.exports = __webpack_public_path__ + "static/hero-illustration-7bc1433bf84a9134f6c931414e6cc332.png";